$(document).on('click', '.size-conversions button', function (e) {
  if ($(this).hasClass('conversion')) {
    $(this).closest('.product-info').attr('converted', '');
  } else {
    $(this).closest('.product-info').removeAttr('converted');
  }
});

$(document).on('click', '.product-card .variant-picker .thumbnail-swatch', function (e) {
  e.preventDefault();
  e.stopPropagation()

  $(this).siblings('.thumbnail-swatch').removeClass('is-selected');
  $(this).addClass('is-selected');

  if ($(this).data('swatch-product-image')) {
    let main_image = $(this).parents('.product-card').find('.product-card__image--primary');
    let alt_image = $(this).parents('.product-card').find('.product-card__image--secondary');

    var newImageElement = document.createElement('img');
    newImageElement.className = 'product-card__image product-card__image--primary  aspect-square';
    newImageElement.setAttribute('width', '1000px');
    newImageElement.setAttribute('height', '1000px');
    newImageElement.setAttribute('src', $(this).data('swatch-product-image'));

    if ($(this).data('swatch-product-alt-image')) {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-alt-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    } else {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    }

  }
  var productItem = this.closest('.product-card');
  var variantHandle = $(this).data("variant-handle");
  var variantUrl = $(this).data("variant-url");
  var variantTitle = $(this).data("variant-title");
  var variantPrice = $(this).data("variant-price");
  var variantComparePrice = $(this).data("variant-compare-price");
  var variantFullPrice = $(this).data("variant-full-price");
  var variantAvailable = $(this).data("variant-available");
  var swatchProductQuickBuy = $(this).data("swatch-product-quickbuy");

  if (variantFullPrice == "true") {
    productItem.classList.remove("Sale");
    productItem.classList.add("Full");
  } else {
    productItem.classList.remove("Full");
    productItem.classList.add("Sale");
  }
  if (variantAvailable == "true") {
    productItem.classList.remove("Sold-Out");
    productItem.classList.add("Available");
  } else {
    productItem.classList.remove("Available");
    productItem.classList.add("Sold-Out");
  }
  productItem.setAttribute('handle', variantHandle);
  productItem.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
  productItem.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
  productItem.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
  productItem.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
  productItem.querySelector('.product-card__quick-buy button').setAttribute('aria-controls', swatchProductQuickBuy);
  console.log(variantHandle);
    
});

$(document).on('click', '.product-card__variations .swatch-products-more', function () {
  $(this).remove();
});
